const noEmpty = (field) => {
  return !(Number(field) !== null && String(field) === 'null') &&
    field && String(field) !== '0'
    && String(field) !== 'null'
    && String(field) !== 'undefined' ? true : false
}
const noEmptyJudgment = (field) => {
  return !(Number(field) !== null && String(field) === 'null') && field 
    && String(field) !== 'null'
    && String(field) !== 'undefined' ? true : false
}
export const formatString4 = val => {
  if (!val || val.length <= 4) {
    return val;
  }
  if (/\S{5}/.test(val)) {
    return val.replace(/\s/g, "").replace(/(.{4})/g, "$1 ");
  }
};

export const formatDate = (val, fmt) => {
  let date = new Date(val*1000)
  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };

  // 遍历这个对象
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      // console.log(`${k}`)
      console.log(RegExp.$1);
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
};

export default{
  noEmptyJudgment,
  noEmpty
}